<template>
    <div :id="id" tabindex="-1" role="dialog" aria-hidden="true"
         class="popup cart__popup js-mgp-popup">
        <i data-element="close_cart_modal_window"
           class="popup__close arcticmodal-close" @click="close()"></i>
        <div class="cart__popup-title" v-if="title" v-html="title"></div>
        <div class="cart__popup-text">
            <div v-html="body"></div>
            <slot></slot>
        </div>
        <div v-if="footer" class="cart__popup-text">
            {{ footer }}
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
/*defaultParam: {
    resizable:false,
    adaptive: false,
    draggable:false,
    scrollable: false,
    focusTrap: false,
    reset: false,
    overlayTransition: 'vm-transition--overlay',
    transition: 'vm-transition--modal',
    clickToClose: true,
    classes: () => [],
    styles: {type: [String, Array, Object]},
    minWidth: 0,
    minHeight: 0,
    maxWidth: Number.MAX_SAFE_INTEGER,
    maxHeight: Number.MAX_SAFE_INTEGER,
    width: 600,
}*/

Vue.use(VModal);

export default {
    name: 'ModalWindowCart',
    props: {
        id: {
            type: String,
            require: true,
        },
        body: {
            type: String,
        },
        title: {
            type: String,
        },
        footer: {
            type: String,
        },
    },
    methods: {
        open() {
            const t = this;
            t.$modal.show(t.id);
        },
        close() {
            const t = this;
            t.$modal.hide(t.id);
            this.$emit('close')
        },
    }
}
</script>